import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import LossReserveTrail from './LossReserveTrail';
import { Accordion } from "react-bootstrap";
import LoadingPage from "../reusableComponents/loader/loadingPage";
import { calculateLossReserveValue,  getLossReserveAudit,getCalculations } from "./lossReserveServiceAPI";
import { editModeOn, getFromDecreaptLocalStorage } from "../utilFunctions";
import { functionalities,RECLOSE } from "../consts";

const LossReserve = ({ roleDataCookie, policyDetailCookie, getClaimDetails }) => {
  const [lossReserveValue, setLossReserveValue] = useState(0);
  const [lossReservePercentage, setLossReservePercentage] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [lossReserveAuditList, setLossReserveAuditList] = useState([]);
  const [loadingAuditList, setLoadingAuditList] = useState(false);
  const [disableLossReserve,setDisableLossReserve]=useState(true);
  const [claimDetailCookie, setClaimDetailCookie] = useState(getFromDecreaptLocalStorage("claimDetail"))
  const [showRemarksModal,setShowRemarksModal] =useState(false)
  const [remarks,setRemarks]=useState('')
  // Format date for API requests
  const formattedDate = claimDetailCookie?.dateAndTimeOfLoss?.split('T')[0];
  useEffect(() => {
    disableLossReservePercentage();
    setLossReservePercentage(claimDetailCookie?.lossReservePercentage?.toFixed(2));
    setLossReserveValue(claimDetailCookie?.lossReserveValue?.toFixed(2));
    getLossReserveAuditTrail();
  }, [claimDetailCookie]);
  useEffect(() => {
    getClaimDetails(claimDetailCookie?.claimNo, false, setClaimDetailCookie)
  },[])


  // Fetch default loss percentage based on product ID and date of loss
  // const getDefaultLossPercentage = async () => {
  //   if (claimDetailCookie?.lossReservePercentage !== null || claimDetailCookie?.lossReserveValue !== null) {
  //     setLossReservePercentage(claimDetailCookie?.lossReservePercentage);
  //     setLossReserveValue(claimDetailCookie?.lossReserveValue);
  //   } else {
  //     const defaultLossPercentage = await getDefaultLossReservePercentage(claimDetailCookie.productID, formattedDate);
  //     setLossReservePercentage(defaultLossPercentage?.lossReserveEntity?.lossReserve);
  //   }
  // };

  // Fetch loss reserve audit trail
  const getLossReserveAuditTrail = async () => {
    setLoadingAuditList(true);
    const data = await getLossReserveAudit(claimDetailCookie?.claimNo);
    setLossReserveAuditList(data?.data?.auditTrial);
    setLoadingAuditList(false);
  };

  // Disable loss reserve percentage update for specific claim statuses
  const disableLossReservePercentage = async () => {
    setLoadingAuditList(true)
    const calculations = await getCalculations(claimDetailCookie)
    const reopenedclaimCalculations = claimDetailCookie?.claimStatus == 'Reopen' ? calculations.filter((data) => {
      const createdDate = new Date(data.calcEntity.createdDate);
      const claimReopenDate = new Date(claimDetailCookie?.claimReopenDate);
      return createdDate > claimReopenDate;
    }) : calculations
    const checkIsCalculated = reopenedclaimCalculations.filter((data) => data.calcEntity.isCalculated == true)
    const completedCalculations = reopenedclaimCalculations.filter((data) => data.calcEntity.calcStatus == 'Completed' || data.calcEntity.calcStatus == 'Rejected' || data.calcEntity.calcStatus == 'Approved')
    const disableLoss = claimDetailCookie?.claimStatus.toLowerCase() === "closed" || claimDetailCookie?.claimStatus.toLowerCase()===RECLOSE ||
      !editModeOn(functionalities.CLAIM_PROCESSING_LOSS_RESERVE_TAB) || completedCalculations.length || checkIsCalculated.length;
    setDisableLossReserve(disableLoss)
    setLoadingAuditList(false)
  };

  // Calculate and update loss reserve value
  const updateLossReserve = async () => {
    if(!remarks){
      toast.error("Please Enter Remarks")
      return
    }
    setShowLoader(true);
    const payload = {
      claimId: claimDetailCookie?.claimNo,
      productId: claimDetailCookie?.productID,
      sowingDate: claimDetailCookie?.policy.sowingDate,
      policyDuration: policyDetailCookie?.policy_duration,
      sumInsured: policyDetailCookie?.sum_insured,
      lossReservePercentage,
      remarks,
      createdBy: roleDataCookie?.userID
    };
    const data = await calculateLossReserveValue(payload);  
    if (data && data?.lossReserveValue !== null ) {            
      if(lossReserveAuditList?.length) toast.success("Loss Reserve Percentage Saved Successfuly")
      setLossReserveValue(data?.lossReserveValue.toFixed(2));
      await getLossReserveAuditTrail();
    getClaimDetails(claimDetailCookie?.claimNo, false, setClaimDetailCookie)
    }
    setShowLoader(false);
    setShowRemarksModal(false)
  };

  return (
    <>
      {loadingAuditList ? <LoadingPage customStyle={{ marginTop: 0 }} /> :
      <div className="inner-box2Field mt-3">
        <Accordion defaultActiveKey="0" alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Loss Reserve Details</Accordion.Header>
            <Accordion.Body>
              <div className="container row">
                <div className="col-lg-3 col-sm-12 col-xs-12">
                  <label htmlFor="lossReserve">Loss Reserve Value (₹)</label>
                  <input
                    type="label"
                    id="lossReserve"
                    disabled
                    className="bg-gray w-100"
                    value={lossReserveValue}
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <label htmlFor="lossReservePercentage">Loss Reserve %</label>
                  <input
                    type="number"
                    id="lossReservePercentage"
                    className="w-100"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value > 100 || value < 0 ) {
                        toast.error('Please enter percentage between 0 to 100');
                        return;
                      }
                      if (value.includes('.') && value.split('.')[1].length > 2) {
                        return;
                      }
                      setLossReservePercentage(value);
                    }}
                    value={lossReservePercentage}
                    disabled={disableLossReserve}
                  />
                </div>
                {editModeOn(functionalities.CLAIM_PROCESSING_LOSS_RESERVE_TAB) &&(
                  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                    <button
                      disabled={disableLossReserve}
                      className="btn btn-success mb-0 px-4 py-1 mt-3 ms-3"
                      onClick={() => {
                        if (claimDetailCookie.lossReservePercentage === lossReservePercentage) {
                          toast.error('This percentage is already configured. Enter a different value.');
                          return;
                        }
                        setShowRemarksModal(true);
                      }}

                    >
                      Submit
                    </button>
                  </div>
                )}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {showRemarksModal &&
          <div id="overlayCalcclaim">
            <div className="overlay_textCalc"><span onclick="off()" className="xCalc glyphicon glyphicon-remove"></span></div>
            <div className="align_overlayCalc">Remarks <span className="asteriskCalc"></span></div>
            <div><textarea type="text" id="reasonCalc" onChange={(e) => {
              const value = e.target.value;
              setRemarks(value)
            }}></textarea></div>
            <div className="back1Calc" onClick={() => setShowRemarksModal(false)}>Cancel</div>
            <div className="submit-3Calc" onClick={updateLossReserve}>Submit</div>
          </div>
        }
        <LossReserveTrail
          claimDetailCookie={claimDetailCookie}
          roleDataCookie={roleDataCookie}
          lossReserveAuditList={lossReserveAuditList}
          setLossReserveAuditList={setLossReserveAuditList}
        />
      </div>
}
      {showLoader && <LoadingPage claimDone />}
    </>
  );
};

export default React.memo(LossReserve);
